export enum DropTypeEnum {
  ROOM = 'room',
}
